import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy } from 'services/WService';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [coverages, setCoverages] = useState([]);
  const [products, setProducts] = useState([]);
  
  function handleChange(field, value) {
    if (typeof value === 'object') {
      setDataChanging((prev) => ({
        ...prev,
        ...value,
      }));
    } else {
      setDataChanging((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  }
  async function listCoverage() {
    let response = await wsGetAll('sale/cobertura-colgate');
    if (response.success) setCoverages(response.data);
  }
  async function listProducts() {
    let response = await wsFindBy('logi/product', { base_business_partner_id: 7, deleted_at: 'null', state: 'A' });
    if (response.success) setProducts(response.data);
  }
  useEffect(() => {
      if (customerPortfolioB.open) {
        if (!customerPortfolioB.id) listCoverage();
        listProducts();
        setDataChanging(customerPortfolioB);
      }
    }, [customerPortfolioB.open]);
  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return { description: item.DESCRIPCION };
        }),
        description: dataImport.nameFile
      });
    } else if (dataImport?.success === false) {
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.id) {
      setDataImport({});
    }
  }, [bPartnerSelect]);
  return (
    <>
      <Modal
        title={`Nueva cuota de categorias`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/group-detail-colgate'
        dataForce={{
          id_cobertura: dataChanging.id_cobertura,
          id_grupo: props.id_grupo,
          ItemCode: dataChanging.ItemCode,
          ItemName: dataChanging.ItemName,
          logi_product_id: dataChanging.logi_product_id,
        }}
      >
        <Autocomplete
          disableClearable
          options={coverages}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Coberturas bimestrales" margin="normal" required />
          )}
          onChange={(e, item) => handleChange('id_cobertura', item?.id)}
          value={coverages.find(coverage => coverage.id === dataChanging.id_cobertura) || null}
        />
        <Autocomplete
          disableClearable
          options={products}
          getOptionLabel={(item) => `${item.ItemName} (Código: ${item.ItemCode})`}
          renderInput={(params) => (
            <TextField {...params} label="Producto" margin="normal" fullWidth />
          )}
          onChange={(e, item) =>
            handleChange('product', {
              ItemCode: item?.ItemCode, ItemName: item?.ItemName, logi_product_id: item?.id,
            })
          }
          value={
            products.find((product) => product.ItemCode === dataChanging.ItemCode) || null
          }
        />
        {/* <TextField
          label="Cuota"
          type="number"
          margin="normal"
          name="cuota"
          required
          fullWidth
        />
        <TextField
          label="Descripción de la categoria"
          type="text"
          margin="normal"
          name="description"
          required
          fullWidth
        /> */}
      </Modal>
    </>
  );
});
